import React, { Component } from "react"
import withRouter, { WithRouterProps } from './Common/withRouter'

interface NonAuthLayoutProps extends WithRouterProps {
  children?: React.ReactNode
}

class NonAuthLayout extends Component<NonAuthLayoutProps> {
  constructor(props: NonAuthLayoutProps) {
    super(props)
    this.state = {}
    this.capitalizeFirstLetter.bind(this)
  }

  capitalizeFirstLetter = (string: string): string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  // componentDidMount() {
  //   let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname)

  //   document.title =
  //     currentage + " | Lexa - Responsive Bootstrap 5 Admin Dashboard"
  // }
  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}

const NonAuthLayoutWithRouter = withRouter(NonAuthLayout)
export default NonAuthLayoutWithRouter as React.ComponentType<{ children?: React.ReactNode }>
